// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__iyWgE","breadcrumbList":"Breadcrumb_breadcrumbList__UjNpQ","breadcrumbItem":"Breadcrumb_breadcrumbItem__B9M2I"};